// Environment config
// In production (Docker), env vars are injected at runtime via window.__ENV__
// In local dev, Vite loads them from .env files via import.meta.env

const runtimeEnv = (typeof window !== 'undefined' && (window as any).__ENV__) || {};

const apiUrl = runtimeEnv.VITE_API_URL || import.meta.env.VITE_API_URL;

if (!apiUrl) {
  throw new Error('VITE_API_URL is required but not set in environment variables.');
}

export const ENV = {
  VITE_API_URL: apiUrl,
  VITE_API_BASE_PATH: runtimeEnv.VITE_API_BASE_PATH || import.meta.env.VITE_API_BASE_PATH || '/api/v1',
  VITE_BDAPI_BASE_URL:
    runtimeEnv.VITE_BDAPI_BASE_URL || import.meta.env.VITE_BDAPI_BASE_URL || 'https://bdapi.vercel.app/api/v.1',
  VITE_WEBSITE_URL:
    runtimeEnv.VITE_WEBSITE_URL || import.meta.env.VITE_WEBSITE_URL || 'http://localhost:5175',
  VITE_PRINT_AGENT_URL:
    runtimeEnv.VITE_PRINT_AGENT_URL || import.meta.env.VITE_PRINT_AGENT_URL || 'http://127.0.0.1:9110',
};
